/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZoneRecord_ZoneRecordInput_zone_record_create = {
    name: string;
    type: ZoneRecord_ZoneRecordInput_zone_record_create.type;
    content: string;
    ttl: number;
    /**
     * Only used for MX records
     */
    priority?: number;
};

export namespace ZoneRecord_ZoneRecordInput_zone_record_create {

    export enum type {
        A = 'A',
        AAAA = 'AAAA',
        CNAME = 'CNAME',
        TXT = 'TXT',
        MX = 'MX',
        SRV = 'SRV',
        NS = 'NS',
        SPF = 'SPF',
        SSHFP = 'SSHFP',
        SOA = 'SOA',
        CAA = 'CAA',
    }


}

